<div class="organisationData__container">
    <div class="organisationData__labeltext" *ngIf="userData?.label">
        {{userData.label}}
    </div>
    <div class="organisationData__valueText" *ngIf="userData?.data">
        {{userData.data}}
    </div>
</div>
